module.exports = {};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_iterators.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_iterators.js
// module chunks = 0